import Vue from 'vue'
import {Drag, Dragover, Drop} from 'vue-drag-drop';

Vue.component('drag', Drag);
Vue.component('drop', Drop);
Vue.component('dragover', Dragover);
